/**
 * Registers `@hsus-dev/session-policy` SessionManager logout callback.
 * All policy expiries use app-only logout (no MSAL `logoutRedirect` / Azure AD session end). **Absolute**
 * expiry also sends cross-portal logout (`emitAuthLogoutSignal`) so other origins align; idle keeps
 * `notifyPeerPortals: false` to preserve SSO for quick re-auth where applicable.
 * `App.tsx` navigates per `SessionEvent.LogoutTriggered` (see `armSessionTimeoutRedirectFromReason`).
 *
 * Must render under `AuthProvider` + `MsalProvider`.
 * Imports `useAuth` from `authReactContext` (not `AuthContext`) to stay cycle-free — see `docs/AUTH_MENTAL_MODEL.md §8`.
 */
import { useEffect } from 'react';
import { SessionLogoutReason } from '@hsus-dev/session-policy';
import { registerSessionLogoutCallback } from '../../services/session.service';
import { useAuth } from '../../context/authReactContext';

export function SessionPolicyLogoutRegistrar(): null {
  const auth = useAuth();

  useEffect(() => {
    registerSessionLogoutCallback((reason: string) => {
      const notifyPeerPortals = reason === SessionLogoutReason.Absolute;
      void auth.logout({ notifyPeerPortals });
    });
  }, [auth]);

  return null;
}
